import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Col, Container, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useLocation, useParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { Button, Grid } from '@mui/material';
import GiftCard from './common/GiftCard';

const Rewards = () => {
    function rewardsSearch(tag,order,page){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/rewards/list").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // ナビゲーション
    const navigate = useNavigate();
    // 検索結果情報
    const [searchPage,setSearchPage] = useState(-1)
    // 検索ワード
    let param = useParams()
    let page = parseInt(param.page)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [tag, setTag] = useState("")
    const [order, setOrder] = useState("")
    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [searching,setSearching] = useState(false)
    const [rewards, setRewards] = useState([])
    const location = useLocation()
    // 現在のURLを取得
    const url = new URL(window.location.href)

    // URLSearchParamsオブジェクトを作成
    const params = new URLSearchParams(url.search)

    // パラメーターをオブジェクトに変換
    const paramsObj = {}
    params.forEach((value, key) => {
        paramsObj[key] = value;
    })

    useEffect(() => {
        let tag = ""
        if(null !== paramsObj.tag && paramsObj.tag !== "すべて"){
            tag = paramsObj.tag
            setTag(tag)
            setSearchPage(parseInt(paramsObj.page || 1))
        } else {
            setTag("")
            setSearchPage(parseInt(paramsObj.page || 1))
        }
    },[location.search])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "特典応募 - アワートAI"
        setSearchPage(parseInt(paramsObj.page || 1))
    },[page])

    useEffect(() => {
        if(searchPage !== -1){
            setSearching(true)
            rewardsSearch(tag,"",searchPage).then(r => {
                if(r.result){
                    // setRewards(r.data.filter(d => d.id !== "bb722250-6218-11ef-b72e-0242ac130004"))
                    setRewards(r.data)
                } else {
                    setRewards([])
                }
                setSearching(false)
            })
        }
    },[tag,searchPage])
      
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        {/* ヘッダーセクション */}
        <Container className='mt-4 mb-4'>
            <Row className="align-items-center">
                <Col>
                    <h1 className="d-flex align-items-center mb-0" style={{
                        fontSize: "28px", 
                        fontWeight: "bold", 
                        color: "#2c5aa0",
                        borderBottom: "3px solid #e3f2fd",
                        paddingBottom: "10px"
                    }}>
                        <Icon.Gift className="me-2" style={{color: "#ff6b35"}} /> 
                        特典応募
                    </h1>
                </Col>
            </Row>
        </Container>

        {/* 応募概要セクション */}
        <Container className='mb-4'>
            <div style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "12px",
                padding: "24px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}>
                <h4 className="mb-4" style={{color: "#495057", fontSize: "20px", fontWeight: "600"}}>
                    <Icon.InfoCircle className="me-2" style={{color: "#17a2b8"}} />
                    応募について
                </h4>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="h-100 p-3" style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #e9ecef"
                        }}>
                            <div className="d-flex align-items-start">
                                <Icon.Calendar className="me-3 mt-1" style={{color: "#28a745", fontSize: "20px"}} />
                                <div>
                                    <h6 className="mb-2" style={{color: "#495057", fontWeight: "600"}}>応募期間</h6>
                                    <p className="mb-1 text-muted">毎月1日～10日</p>
                                    <small className="text-muted">※12月のみ：1日～15日</small>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="h-100 p-3" style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #e9ecef"
                        }}>
                            <div className="d-flex align-items-start">
                                <Icon.Award className="me-3 mt-1" style={{color: "#ffc107", fontSize: "20px"}} />
                                <div>
                                    <h6 className="mb-2" style={{color: "#495057", fontWeight: "600"}}>当選発表・発送</h6>
                                    <p className="mb-1 text-muted">11日発表、12日～月末発送</p>
                                    <small className="text-muted">※12月：16日発表、17日～月末発送</small>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="mt-4 p-3" style={{
                    background: "linear-gradient(135deg, #e7f3ff 0%, #cce7ff 100%)",
                    border: "1px solid #b3d7ff",
                    borderRadius: "8px"
                }}>
                    <div className="d-flex align-items-center">
                        <Icon.Star className="me-2" style={{color: "#007bff", fontSize: "18px"}} />
                        <strong style={{color: "#0056b3"}}>プレミアムプラン特典：</strong>
                        <span className="ms-2" style={{color: "#495057"}}>10口分をポイント消費なしで応募可能</span>
                    </div>
                </div>
            </div>
        </Container>

        {/* 注意事項セクション */}
        <Container className='mb-5'>
            <div style={{
                backgroundColor: "#fff8e1",
                border: "1px solid #ffcc02",
                borderRadius: "12px",
                padding: "24px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}>
                <h5 className="mb-4" style={{color: "#f57c00", fontSize: "20px", fontWeight: "600"}}>
                    <Icon.ExclamationTriangle className="me-2" style={{color: "#f57c00"}} />
                    重要な注意事項
                </h5>
                <Row className="g-3">
                    <Col lg={6}>
                        <div className="h-100">
                            <div className="mb-3 p-3" style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div className="d-flex align-items-start">
                                    <Icon.CheckCircle className="me-3 mt-1" style={{color: "#28a745", fontSize: "18px"}} />
                                    <div>
                                        <h6 className="mb-1" style={{color: "#495057", fontWeight: "600"}}>応募条件</h6>
                                        <small className="text-muted">SMS認証済・
                                        <Link to={"/manage/id"} className="text-decoration-none fw-bold">本人確認済</Link>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 p-3" style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div className="d-flex align-items-start">
                                    <Icon.House className="me-3 mt-1" style={{color: "#17a2b8", fontSize: "18px"}} />
                                    <div>
                                        <h6 className="mb-1" style={{color: "#495057", fontWeight: "600"}}>発送先</h6>
                                        <small className="text-muted">本人確認時の住所を使用</small>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3" style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div className="d-flex align-items-start">
                                    <Icon.Building className="me-3 mt-1" style={{color: "#6f42c1", fontSize: "18px"}} />
                                    <div>
                                        <h6 className="mb-1" style={{color: "#495057", fontWeight: "600"}}>集合住宅の方</h6>
                                        <small className="text-muted">
                                            <span style={{color: "#dc3545", fontWeight: "bold"}}>建物名・部屋番号</span>
                                            まで必須
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="h-100">
                            <div className="mb-3 p-3" style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div className="d-flex align-items-start">
                                    <Icon.Globe className="me-3 mt-1" style={{color: "#fd7e14", fontSize: "18px"}} />
                                    <div>
                                        <h6 className="mb-1" style={{color: "#495057", fontWeight: "600"}}>配送対象</h6>
                                        <small className="text-muted">日本国内のみ</small>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3" style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div className="d-flex align-items-start">
                                    <Icon.XCircle className="me-3 mt-1" style={{color: "#dc3545", fontSize: "18px"}} />
                                    <div>
                                        <h6 className="mb-1" style={{color: "#495057", fontWeight: "600"}}>キャンセル</h6>
                                        <small className="text-muted">ポイントは返還されません</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="text-center mt-4">
                    <Link to={"/rewardsHistory"}>
                        <Button 
                            variant='outlined' 
                            className='px-4 py-2'
                            style={{
                                borderColor: "#007bff",
                                color: "#007bff",
                                fontWeight: "600",
                                borderRadius: "8px",
                                textTransform: "none"
                            }}
                        >
                            <Icon.Clock className="me-2" />
                            応募履歴の確認
                        </Button>
                    </Link>
                </div>
            </div>
        </Container>
        {/* ローディング表示 */}
        {searching && (
            <Container className="text-center py-5">
                <Spinner animation="border" variant="primary" style={{width: "3rem", height: "3rem"}} />
                <div className="mt-3" style={{color: "#6c757d"}}>
                    特典情報を読み込み中...
                </div>
            </Container>
        )}

        {/* ギフトカードセクション */}
        {!searching && (
            <Container className='mb-5'>
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h3 style={{color: "#495057", fontSize: "22px", fontWeight: "600", margin: "0"}}>
                        <Icon.Gift className="me-2" style={{color: "#ff6b35"}} />
                        応募可能な特典
                    </h3>
                    {rewards.length > 0 && (
                        <Badge bg="primary" style={{fontSize: "14px", padding: "8px 12px"}}>
                            {rewards.length}件の特典
                        </Badge>
                    )}
                </div>
                
                {rewards.length > 0 ? (
                    <Grid container spacing={3}>
                        {rewards.map((d, i) => {
                            if (i === 50) return null;
                            return (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={d.id || i}>
                                    <GiftCard data={d} />
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <div className="text-center py-5" style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "2px dashed #dee2e6"
                    }}>
                        <Icon.GiftFill size={48} style={{color: "#dee2e6", marginBottom: "16px"}} />
                        <h5 style={{color: "#6c757d", marginBottom: "8px"}}>現在応募可能な特典はありません</h5>
                        <p style={{color: "#adb5bd", margin: "0"}}>新しい特典が追加されるまでお待ちください</p>
                    </div>
                )}
            </Container>
        )}

        {/* ページネーション */}
        {!searching && rewards.length > 0 && (
            <Container className="d-flex justify-content-center mb-5">
                <div className="d-flex align-items-center gap-3" style={{
                    padding: "12px 20px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6"
                }}>
                    {searchPage > 1 ? (
                        <Button 
                            variant='outlined' 
                            onClick={() => {
                                let page = searchPage - 1;
                                navigate("/rewards/" + page + (tag ? "?tag=" + tag : ""));
                                window.scrollTo({top: 0, left: 0, behavior: "smooth"});
                            }}
                            style={{
                                borderColor: "#007bff",
                                color: "#007bff",
                                fontWeight: "500",
                                minWidth: "80px"
                            }}
                        >
                            <Icon.ChevronLeft className="me-1" />
                            {t("common.prev")}
                        </Button>
                    ) : (
                        <Button 
                            variant='outlined' 
                            disabled 
                            style={{minWidth: "80px", opacity: "0.5"}}
                        >
                            <Icon.ChevronLeft className="me-1" />
                            {t("common.prev")}
                        </Button>
                    )}
                    
                    <span style={{
                        padding: "8px 16px",
                        backgroundColor: "#007bff",
                        color: "white",
                        borderRadius: "6px",
                        fontWeight: "500",
                        minWidth: "80px",
                        textAlign: "center"
                    }}>
                        {searchPage}
                    </span>
                    
                    {rewards.length >= 50 ? (
                        <Button 
                            variant='outlined' 
                            onClick={() => {
                                let page = searchPage + 1;
                                navigate("/rewards/" + page + (tag ? "?tag=" + tag : ""));
                                window.scrollTo({top: 0, left: 0, behavior: "smooth"});
                            }}
                            style={{
                                borderColor: "#007bff",
                                color: "#007bff",
                                fontWeight: "500",
                                minWidth: "80px"
                            }}
                        >
                            {t("common.next")}
                            <Icon.ChevronRight className="ms-1" />
                        </Button>
                    ) : (
                        <Button 
                            variant='outlined' 
                            disabled 
                            style={{minWidth: "80px", opacity: "0.5"}}
                        >
                            {t("common.next")}
                            <Icon.ChevronRight className="ms-1" />
                        </Button>
                    )}
                </div>
            </Container>
        )}

        <Footer />
    </div>
    )
}

export default Rewards;
